import React from 'react';
import classNames from 'classnames';
import { translationProvider } from 'twain-sport-fe-mono/store/translations';
import { IStandingsMatch } from 'twain-sport-fe-mono/interfaces';
import { MatchStatus } from 'twain-sport-fe-mono/enums';
import {
    CameraIcon,
    LockIcon,
    MoneySendIcon,
    VideoPlayCircleIcon,
} from 'twain-sport-fe-mono/icons';
import { useStandingsContext } from 'twain-sport-fe-mono/context';
import classes from './StandingsMatchStatus.module.scss';

interface IProps {
    match: IStandingsMatch;
}

export const StandingsMatchStatus: React.FC<IProps> = (props) => {
    const { Link, getMatchVideoUrl, getMatchUrl, getBetUrl } = useStandingsContext();

    if (props.match.status === MatchStatus.FINISHED || props.match.wasPostponed) {
        return (
            <Link to={getMatchVideoUrl(props.match.code)} className={classes.link}>
                <CameraIcon className={classes.icon} />
                <span className={classes.label}>{translationProvider.string('match_info')}</span>
            </Link>
        );
    }

    if (
        props.match.status === MatchStatus.OPENED &&
        props.match.startsAt > Date.now() &&
        getBetUrl
    ) {
        return (
            <Link to={getBetUrl(props.match.code)} className={classes.link}>
                <MoneySendIcon className={classes.icon} />
                <span className={classes.label}>{translationProvider.string('bet')}</span>
            </Link>
        );
    }

    if (props.match.status === MatchStatus.OPENED && props.match.startsAt <= Date.now()) {
        return (
            <Link to={getMatchUrl()} className={classes.link}>
                <VideoPlayCircleIcon className={classes.icon} />
                <span className={classes.label}>{translationProvider.string('live')}</span>
            </Link>
        );
    }

    return (
        <div className={classNames(classes.link, classes.disabled)}>
            <LockIcon className={classes.icon} />
            <span className={classes.label}>{translationProvider.string('unavailable')}</span>
        </div>
    );
};
